<template>
  <div>
    <template v-if="selected">
      <div class="card card-select btn-light" @click="handleInputClick()">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-grow-1">
              <person-label :person="selected" />
            </div>
            <div>
              <button class="btn btn btn-light" @click.stop="handleClear()">
                <i class="text-info fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card" @click="handleInputClick()">
        <div class="card-body">Selecionar pessoa</div>
      </div>
    </template>

    <b-modal ref="modal" header-class="border-bottom-0" size="lg" hide-footer>

      <template #modal-header>
        <h5>Pesquisar pessoa</h5>
        <b-button
          v-b-tooltip.hover
          class="text-success"
          @click="handleNewPerson()"
          variant="outline-light"
          title="Adicionar nova Pessoa"
        >
          <i class="fas fa-plus" />
        </b-button>

      </template>

      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <text-input
              class="ml-0"
              v-model="form.name"
              placeholder="Perquisar pessoa..."
              @input="select(1)"
            />
          </div>
        </div>
        <table-paginator :data="persons" @pagechange="handlePageChange($event)">
          <template v-for="person in persons.data">
            <div
              class="row py-3 row-seletable"
              :key="person.id"
              @click="handleInput(person)"
            >
              <div class="col-md-12 d-flex">
                <div>
                  <person-label :person="person" />
                </div>
              </div>
            </div>
          </template>
        </table-paginator>
      </div>
    </b-modal>
    <PersonForm ref="PersonForm" @stored="select()" />
  </div>
</template>

<script>
import tablePaginator from "@/components/sections/TablePaginator";
import personLabel from "@/components/person/sections/PersonLabel";
import PersonForm from "@/components/forms/PersonForm";

export default {
  components: { personLabel, tablePaginator, PersonForm },

  props: {
    value: {},
    personType: {
      default : 'c'
    },
  },

  data: () => ({
    selected: null,
    form: {
      name: null,
      page: 1,
      person_type: ["s"],
      status: 1,
    },
  }),

  async created() {
    this.selected = this.value;
  },

  computed: {
    persons() {
      return this.$store.state.person.persons;
    },
  },

  watch: {
    value (val) {
      this.selected = val
    }
  },

  methods: {
    async select(page = 1) {
      this.form.page = page;
      this.form.type = this.personType;
      await this.$store.dispatch("person/getPersons", this.form);
    },

    async handleInputClick() {
      await this.select();
      this.$refs.modal.show();
    },

    handlePageChange(page) {
      this.select(page);
    },

    handleInput(person) {
      this.selected = person;
      this.$emit("input", this.selected);
      this.$refs.modal.hide();
    },

    handleClear() {
      this.selected = null;
      this.$emit("input", this.selected);
    },
    handleNewPerson() {
      this.$refs.PersonForm.open();
    },
  },
};
</script>

<style scoped>
.row-seletable {
  cursor: pointer;
  border-radius: 0.25rem;
  margin-left: 5px;
  margin-right: 5px;
}

.row-seletable:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
/* .card-select {
  cursor: pointer;
} */

/* .card-selected {
  border-color: #8bc34a;
}

.card-selectable:hover {
  border-color: #8bc34a;
} */
</style>